import type { SVGProps } from 'react';
import * as React from 'react';
import { forwardRef, Ref } from 'react';

const SvgEyeClose = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 16 16"
    ref={ref}
    {...props}
  >
    <path
      fill="currentColor"
      d="M3.223 2.162a.48.48 0 0 0-.332-.168.46.46 0 0 0-.348.13.5.5 0 0 0-.156.349.52.52 0 0 0 .128.361l1.15 1.323C1.495 5.551.56 7.698.52 7.796a.52.52 0 0 0 0 .406c.02.05.527 1.223 1.652 2.4 1.5 1.567 3.393 2.396 5.477 2.396a7.3 7.3 0 0 0 3.112-.677l1.314 1.513a.48.48 0 0 0 .332.168.46.46 0 0 0 .348-.13.5.5 0 0 0 .156-.349.52.52 0 0 0-.128-.361zm2.828 4.74 2.49 2.865a1.84 1.84 0 0 1-1.222.2 1.9 1.9 0 0 1-1.084-.624 2.071 2.071 0 0 1-.185-2.44m1.598 5.096c-1.839 0-3.446-.7-4.776-2.078a8.3 8.3 0 0 1-1.379-1.922c.28-.55 1.175-2.087 2.83-3.086l1.075 1.234a3.1 3.1 0 0 0-.605 1.96c.025.706.289 1.381.744 1.905a2.83 2.83 0 0 0 1.744.955 2.77 2.77 0 0 0 1.922-.445l.88 1.013a6.4 6.4 0 0 1-2.435.464m.359-5.964a.48.48 0 0 1-.306-.21.52.52 0 0 1 .127-.695.46.46 0 0 1 .358-.078c.61.124 1.164.45 1.582.93.417.48.675 1.09.735 1.735a.52.52 0 0 1-.108.366.47.47 0 0 1-.324.179h-.044a.47.47 0 0 1-.324-.13.5.5 0 0 1-.154-.324 2.05 2.05 0 0 0-.49-1.154 1.9 1.9 0 0 0-1.052-.62m6.769 2.168c-.025.059-.63 1.46-1.993 2.737a.47.47 0 0 1-.348.133.46.46 0 0 1-.333-.166.5.5 0 0 1-.121-.366.52.52 0 0 1 .164-.346 8.3 8.3 0 0 0 1.661-2.196 8.3 8.3 0 0 0-1.381-1.923c-1.33-1.378-2.937-2.077-4.777-2.077a7 7 0 0 0-1.157.098.46.46 0 0 1-.359-.084.5.5 0 0 1-.195-.326.52.52 0 0 1 .083-.374.49.49 0 0 1 .314-.202 7.7 7.7 0 0 1 1.314-.112c2.085 0 3.978.829 5.478 2.397 1.125 1.177 1.63 2.351 1.652 2.4a.52.52 0 0 1 0 .407z"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgEyeClose);
export default ForwardRef;
